export default __webpack_public_path__ + "static/starter-img-baf1db451b9250c023b7f329c1507386.png";